// 구매 한 번 — 결제 세션을 만들고 유저를 플랫폼 결제 페이지로 보낸다. 화면은 이 훅만 안다
import { useEffect, useState } from 'react';

import { useSession } from '../../../composition/plugin-runtime';
import { createCheckout } from '../adapters/checkout-api';
import { readReturn, returnToOf, type CheckoutError, type CheckoutReturn } from '../domain/checkout';

/** 결제에서 돌아온 주소면 결과를 읽는다. 읽기만 한다 — StrictMode 가 초기화 함수를 두 번 불러도 같은 답이 나와야 한다 */
function readBack(): CheckoutReturn | null {
  return typeof window === 'undefined' ? null : (readReturn(window.location.search)?.result ?? null);
}

/** 주소창에서 결제 값을 지운다 — 새로 고칠 때마다 「결제됐어요」가 다시 뜨지 않게 */
function clearBack(): void {
  const back = readReturn(window.location.search);
  if (back) window.history.replaceState(window.history.state, '', window.location.pathname + back.rest + window.location.hash);
}

export function useCheckout(platformUrl: string, product: string) {
  const session = useSession();
  const [back] = useState(readBack);
  useEffect(clearBack, []);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<CheckoutError | null>(null);

  async function buy(): Promise<void> {
    if (!session || busy) return;
    setBusy(true);
    setError(null);
    const result = await createCheckout(platformUrl, session.token, product, returnToOf(window.location.href));
    if (result.ok) {
      window.location.assign(result.url); // 플랫폼 결제 페이지로 — 카드 정보는 이 MVP 를 지나가지 않는다
      return;
    }
    setError(result.error);
    setBusy(false);
  }

  return { signedIn: session !== null, back, busy, error, buy };
}
